export const loadedScriptsCache = new Set<string>();

export async function pause(ms: number) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
